<template>
<div class="vliveBatchExport form dialog-form">
    <el-dialog title="批量导出" :visible.sync="dialogVisible">
        <div class="filters">
            <div class="search">
                <el-date-picker class="dateInput" v-model="param.date" type="daterange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
                <el-button type="primary" plain>筛选</el-button>
            </div>
        </div>
        <el-table :data="tableData" style="width: 100%" @select="selected" ref="multipleTable">
            <el-table-column type="selection" width="30"></el-table-column>
            <el-table-column type="index" width="50" label="序号"></el-table-column>
            <el-table-column label="活动名称" prop="name"></el-table-column>
            <el-table-column label="活动时间" prop="date"></el-table-column>
        </el-table>
        <page :total="total" @getList="_getList"></page>
    </el-dialog>
</div>
</template>

<script>
import Page from 'base/page/page'
export default {
    name: 'vliveBatchExport',
    data() {
        return {
            param: {
                date: ''
            },
            dialogVisible: false,
            item: {},
            rules: {},
            imgRule: {
                cls: 'icon_headImg',
                accept: 'image/png,image/jpeg',
                size: 5,
                width: 120,
                height: 120
            },
            tableData: [
                {
                    date: '2016-05-02',
                    status: 1,
                    name: '王小虎1',
                    address: '上海市普陀区金沙江路 1518 1212'
                }, {
                    date: '2016-05-04',
                    status: 2,
                    name: '王小虎2',
                    address: '上海市普陀区金沙江路 1517 弄'
                }, {
                    date: '2016-05-01',
                    status: 3,
                    name: '王小虎3',
                    address: '上海市普陀区金沙江路 1519 弄'
                }, {
                    date: '2016-05-03',
                    status: 4,
                    name: '王小虎4',
                    address: '上海市普陀区金沙江路 1516 弄'
                }, {
                    date: '2016-05-03',
                    status: 5,
                    name: '王小虎5',
                    address: '上海市普陀区金沙江路 1516 弄'
                }
            ],
            total: 50
        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        selected(selection, row) {

        },
        openDialog(row) {
            this.dialogVisible = true
            this.item = row
        },
        _getList() {

        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveBatchExport {
    .el-dialog .el-button{
        margin-bottom: 0;
        margin-left: 30px;
    }
    .el-date-editor .el-range-separator,.filters .el-input__icon{
        line-height: 26px;
    }
}
</style>
